import _ from 'lodash';
import React, { FunctionComponent } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Model from '../../model/ShopKeeper.model';
import { IDefaultPart } from '../../typings/DefaultPart';

interface IProps {
  apply: (defaultPartNum: string) => void;
  container: Object;
  hide: Function;
  model: Model;
  show: boolean;
}

const defaultPartSelectorModal: FunctionComponent<IProps> = ({ apply, container, hide, model, show }) => {
  const defaultParts: IDefaultPart[] = Array.from(model.defaultParts)
    .sort((a, b) => {
      const str1 = a[0].toUpperCase();
      const str2 = b[0].toUpperCase();

      if (str1 < str2) {
        return -1;
      } else if (str1 > str2) {
        return 1;
      } else {
        return 0;
      }
    })
    .map(x => x[1]);

  return (
    <Modal
      backdrop="static"
      container={container as any}
      dialogClassName="sk-defaultPartSelectorModal"
      onHide={hide as any}
      show={show}
    >
      <Modal.Header closeButton={true}>
        <Modal.Title>Additional Line Items</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table className="table">
          <thead>
            <tr>
              <th>ITEM</th>
              <th>DESCRIPTION</th>
            </tr>
          </thead>
          <tbody>
            {defaultParts.map((defaultPart, index) => (
              <tr className="sk-selectorRow" key={index} onClick={() => apply(defaultPart.partNum)}>
                <td>{defaultPart.partNum}</td>
                <td>{defaultPart.desc}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => hide()} variant="secondary">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default defaultPartSelectorModal;
